import * as crypto from "crypto"
import isFeatureEnabled from "shared/featureflags/helperFunctions"
import { readCookieByKey, isInIframe } from "shared/imports/sharedHelperFunctions"

export class EncryptedStorage {
    private IV_LENGTH = 16

    encrypt(value: string): string {
        const iv = crypto.randomBytes(this.IV_LENGTH)
        const key = crypto.createHash("sha256").update(readCookieByKey("user_timeout")).digest()
        const cipher = crypto.createCipheriv("aes-256-cbc", key, iv)
        let encrypted = cipher.update(value, "utf8", "base64")
        encrypted += cipher.final("base64")
        return iv.toString("base64") + ":" + encrypted
    }

    decrypt(value: string) {
        const [ivStr, encrypted] = value.split(":")
        const iv = Buffer.from(ivStr, "base64")
        const timeoutString = readCookieByKey("user_timeout")
        const timeoutParsed = JSON.parse(timeoutString)
        const timeoutDate = new Date(timeoutParsed)
        const isDateInvalid = isNaN(timeoutDate.getTime())
        if (timeoutDate < new Date() || isDateInvalid) return "{}"
        const key = crypto.createHash("sha256").update(timeoutString).digest()
        const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv)
        try {
            let decrypted = decipher.update(encrypted, "base64", "utf8")
            decrypted += decipher.final("utf8")
            return decrypted
        } catch (error) {
            console.error(error)
            return "{}"
        }
    }
}

export class UserdataStorageManager extends EncryptedStorage {
    private storage: Storage
    private persistData: boolean

    constructor() {
        super()
        this.persistData = this.shouldPersistData()
        this.storage = this.persistData ? localStorage : sessionStorage
    }

    private shouldPersistData() {
        return !isInIframe() && isFeatureEnabled("ff_ngg_persist_pii")
    }

    setItem(key: string, value: string) {
        if (this.persistData) {
            const encrypted = this.encrypt(JSON.stringify(value))
            this.storage.setItem(key, encrypted)
            return
        }
        this.storage.setItem(key, JSON.stringify(value))
    }

    getItem(key: string) {
        let storedValue = this.storage.getItem(key)
        if (!storedValue) return {}
        if (this.persistData) storedValue = this.decrypt(storedValue)
        return JSON.parse(storedValue)
    }

    removeItem(key: string) {
        this.storage.removeItem(key)
    }
}

export const userdataStorage = new UserdataStorageManager()
